import { useState, createContext } from "react";

import Graphic from "@arcgis/core/Graphic";

const EvaluatorContext = createContext<
  Partial<{
    gpArray: any | null;
    gpJson: any | null;
    parkArray: Graphic[];
    trailArray: Graphic[];
    setGpArray: (gpArray: any | null) => void;
    setGpJson: (gpJson: any | null) => void;
    setParkArray: (parkArray: any) => void;
    setTrailArray: (trailArray: any) => void;
  }>
>({});
export default EvaluatorContext;

export function EvaluatorProvider(props: any) {
  const [gpArray, setGpArray] = useState<any>();
  const [gpJson, setGpJson] = useState<any>();
  const [parkArray, setParkArray] = useState<Graphic[]>();
  const [trailArray, setTrailArray] = useState<Graphic[]>();

  return (
    <EvaluatorContext.Provider
      value={{
        gpArray,
        gpJson,
        parkArray,
        trailArray,
        setGpArray,
        setGpJson,
        setParkArray,
        setTrailArray,
      }}
      {...props}
    ></EvaluatorContext.Provider>
  );
}
